import { Box, Grid, Link, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const SummaryCard = (props) => {
  const {
    protocolNumber,
    protocolNumber2,
    status,
    created,
    updated,
    submitted,
    installmentAmount,
    totalAmount,
    type,
    applicationId,
    applicationIdentifier,
    applicationProtocolNumber,
    settings,
  } = props;

  const hasApplicationInfo =
    applicationIdentifier || applicationProtocolNumber;
  const applicationTitle =
    applicationIdentifier ??
    (applicationProtocolNumber ? `ΜΗΔ #${applicationProtocolNumber}` : "");
  const canNavigateToApp = settings?.canNavigateToApp === true && applicationId;

  return (
    <Grid sx={{ padding: 4 }} container className="card">
      <Grid align="center" item xs={12}>
        <strong>ΑΙΤΗΣΗ ΕΚΤΑΜΙΕΥΣΗΣ </strong>
        <p>
          <strong>{type}</strong>
        </p>
      </Grid>
      <Grid sx={{ padding: 2 }} align="center" item xs={12} mb={1}>
        <Typography variant="h5">
          Πρόγραμμα «Ημιαυτόνομης διαβίωσης σε διαμερίσματα ατόμων δεκαπέντε
          ετών και άνω που διαβιούν σε Μονάδες Παιδικής Προστασίας και
          Φροντίδας»
        </Typography>
      </Grid>
      {hasApplicationInfo && (
        <Grid item xs={12} sx={{ mb: 1.5, px: { xs: 0, md: 1 } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: { xs: 0.75, md: 1.25 },
              px: 1.25,
              py: 0.75,
              color: "#374151",
              backgroundColor: "#fafafa",
              borderTop: "1px solid",
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                minWidth: 0,
              }}
            >
              <DescriptionOutlinedIcon color="primary" fontSize="small" />
              <Typography
                variant="body2"
                sx={{ color: "#374151", fontWeight: 600, lineHeight: 1.4 }}
              >
                Αρχική αίτηση:{" "}
                <Typography
                  component="span"
                  sx={{ color: "#111827", fontWeight: 800 }}
                >
                  ΜΗΔ {applicationTitle}
                </Typography>
              </Typography>
            </Box>
            {canNavigateToApp && (
              <Link
                href={`/application/${applicationId}`}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  px: 1,
                  py: 0.25,
                  color: "primary.main",
                  border: "1px solid",
                  borderColor: "primary.main",
                  borderRadius: 1,
                  fontWeight: 800,
                  fontSize: "0.8rem",
                  lineHeight: 1.5,
                  textDecoration: "none",
                  "&:hover": {
                    backgroundColor: "primary.main",
                    color: "#fff",
                    textDecoration: "none",
                  },
                }}
              >
                Προβολή
                <OpenInNewIcon sx={{ fontSize: 16 }} />
              </Link>
            )}
          </Box>
        </Grid>
      )}
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">Κατ. Αίτησης:</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography>{status?.name} </Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">Ημ. Δημιουργίας</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography>{created?.dateFormatted}</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">Ποσό Εκταμίευσης</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography>{installmentAmount}</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6}>
          <Typography fontWeight="bold">Συνολικός Π/Υ</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{totalAmount}</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">A/A Υποβολής:</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography>
            {protocolNumber ?? "(δίνεται μετά την Υποβολή)"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6}>
          <Typography fontWeight="bold">Ημ. Υποβολής:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{submitted?.dateFormatted ?? ""}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SummaryCard;
